export default "__VITE_ASSET__7f95e534__"